import { isValidPhoneNumber } from '@src/utils/isValidPhoneNumber'
import { CountryCode } from 'libphonenumber-js'
import { z } from 'zod'

export const supportFormValidation = (
  currentSubject: string | undefined,
  t: (key: string) => string,
  countryCode: CountryCode = 'GB'
) => {
  const isOrderIssues = currentSubject === t('subjectOptions.order_issues')

  return z.object({
    subject: z.string({
      required_error: t('subject.validation.required_error'),
    }),
    firstName: z
      .string({ required_error: t('first_name.validation.required_error') })
      .min(2, {
        message: t('first_name.validation.minimum_required_characters'),
      }),
    lastName: z
      .string({ required_error: t('last_name.validation.required_error') })
      .min(2, {
        message: t('last_name.validation.minimum_required_characters'),
      }),
    emailAddress: z
      .string({
        required_error: t('email_address.validation.required_error'),
        invalid_type_error: t('email_address.validation.invalid_type_error'),
      })
      .email(),
    phoneNumber: z
      .string({
        required_error: t('phone_number.validation.required_error'),
        invalid_type_error: t('phone_number.validation.invalid_type_error'),
      })
      .refine(
        val => isValidPhoneNumber(val, countryCode),
        t('phone_number.validation.invalid_type_error')
      ),
    orderNumber: isOrderIssues
      ? z
          .string({
            required_error:
              t('order_number.validation.required_error') ||
              'Order number is required for order issues',
          })
          .min(
            1,
            t('order_number.validation.required_error') ||
              'Order number is required for order issues'
          )
      : z.string().optional(),
    message: z
      .string({ required_error: t('message.validation.required_error') })
      .min(2, {
        message: t('message.validation.minimum_required_characters'),
      }),
  })
}
